import React, { Suspense } from "react";
import { useToast } from "../../../context/toast-context";
import {
  Col,
  Dialog,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import ErrorBoundary from "../../../utils/error-boundary";
import { FAMILY_FORM_FIELDS } from "./family-constant";
import FamilyList from "./family-list";
import useEmployeeFamilyService from "./use-family-service";

const FamilyInfo = () => {
  const { showToastMessage } = useToast();

  const {
    getInputFieldPropsFn,
    handleSubmit,
    setSelectedFile,
    setPreviewURL,
    resource,
    employeeFamilyInput,
    handleClose,
    handleClickOpen,
    setOpen,
    handleResetForm,
    createFormUpdateLoading,
    open,
    deleteDialogShow,
    handleDeleteDialogOpen,
    handleDeleteFamilyFn,
    selectedFile

  } = useEmployeeFamilyService();

  return (
    <>
      <ErrorBoundary
        fallback={<p>Something went wrong in fetching Owener list...</p>}
      >
        <Suspense fallback={<p>Loading Owener list...</p>}>
          <FamilyList
            getInputFieldPropsFn={getInputFieldPropsFn}
            resource={resource}
            handleResetForm={handleResetForm}
            setOpen={setOpen}
            handleSubmitFn={handleSubmit}
            handleClickOpen={handleClickOpen}
            setPreviewURL={setPreviewURL}
            setSelectedFile={setSelectedFile}
            handleDeleteDialogOpen={handleDeleteDialogOpen}
            selectedFile={selectedFile}
          />
        </Suspense>
      </ErrorBoundary>

      <Gap height={50} />

      {/* Modal */}
      <Dialog
        title={`${employeeFamilyInput?.family_id ? "Update" : "Create New"}  Family`}
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        separator
        btnLoading={createFormUpdateLoading}
        buttonName={employeeFamilyInput?.family_id ? "Update" : "Save"}
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.name.name)}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.relationship.name)}
            />
          </Col>

          <Col sm={6}>
            <SelectField
              {...getInputFieldPropsFn(
                FAMILY_FORM_FIELDS.is_depend_on_family.name
              )}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.date_of_birth.name)}
              // valueSinc
              // onKeyDown={e=>e.preventDefault()}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.contact_no.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              {...getInputFieldPropsFn(FAMILY_FORM_FIELDS.address.name)}
            />
          </Col>

          <Col sm={6}>
            <InputField
              type="file"
              fullWidth
              label="ID Proof"
              placeholder="Upload File"
              valueSinc={true}
              helperText={selectedFile?.name}
              onChange={(event) => {
                const file = event.target.files[0];
                if (file) {
                  const maxSizeInBytes = 2 * 1024 * 1024;
                  if (file.size > maxSizeInBytes) {
                    showToastMessage({
                      message: "File size should not exceed 2 MB.",
                      color: "danger",
                    });
                    return; 
                  }
                  const allowedTypes = [
                    "image/jpeg",
                    "image/jpg",
                    "application/pdf",
                    "image/png",
                  ];

                  if (!allowedTypes.includes(file.type)) {
                    showToastMessage({
                      message: "Only JPG/PNG/PDF files are allowed.",
                      color: "danger",
                    });
                    return;
                  }
                  setSelectedFile(file);
                  setPreviewURL(URL.createObjectURL(file));
                }
              }}
            />
          </Col>
        </Row>
      </Dialog>
   
      <Dialog
        title={`Confirm Delete`}
        fullWidth
        maxWidth="xs"
        closeButton={false}
        open={deleteDialogShow}
        onClose={handleClose}
        onSubmit={handleDeleteFamilyFn}
        btnLoading={createFormUpdateLoading}
        buttonName={"Delete"}
      >
        
        <Typography variant="body2" py={"20"}>Are you sure to delete family details ?</Typography>
      </Dialog>
    </>
  );
};

export default FamilyInfo;
